
import { PlatformType } from '../../../../platform_type';
export const snippetConstants = {};
snippetConstants[PlatformType.Shopify] = {};

snippetConstants[PlatformType.Shopify]['yotpoJS'] = '<script type="text/javascript">' +
  '(function e(){var e=document.createElement("script");e.type="text/javascript",' +
  'e.async=true,e.src="//staticw2.yotpo.com/:app_key/widget.js";' +
  'var t=document.getElementsByTagName("script")[0];t.parentNode.insertBefore(e,t)})();</script>';

snippetConstants[PlatformType.Shopify]['yotpoJSWidgetV3'] = '<script src="https://cdn-widgetsrepository.yotpo.com/v1/loader/:app_key" async></script>';

snippetConstants[PlatformType.Shopify]['reviewsWidget'] = '<div class="yotpo yotpo-main-widget"' +
  ' data-product-id="{{ product.id }}" data-name="{{ product.title | escape }}" ' +
  'data-url="{{ shop.url }}{{ product.url }}"' + ' data-image-url="{{ product.featured_image | product_img_url: ' +
  '"large" |replace: \'?\', \'%3F\' | replace: \'&\',\'%26\'}}" data-description="{{ product.description | escape }}"></div>';

snippetConstants[PlatformType.Shopify]['reviewsWidgetV3'] = '<div class="yotpo-widget-instance"' +
  ' data-yotpo-instance-id=":widget_instance_id" data-yotpo-product-id="{{product.id}}" data-yotpo-name="{{ product.title | escape }}" data-yotpo-url="{{ shop.url }}{{ product.url }}" ' +
  ' data-yotpo-image-url="{{ product.featured_image | product_img_url: "large" |replace: \'?\', \'%3F\' | replace: \'&\',\'%26\'}}" ' +
  ' data-yotpo-description="{{ product.description | escape }}"></div>';

snippetConstants[PlatformType.Shopify]['conversionTracking'] = '<img src="https://api.yotpo.com/conversion_tracking.gif?' +
  'app_key=:app_key&order_id={{order_name|handleize}}&order_amount={{subtotal_price|money_without_currency}}&' +
  'order_currency={{ shop.currency }}" width="1" height="1">';

snippetConstants[PlatformType.Woocommerce] = {};

snippetConstants[PlatformType.Woocommerce]['app_key'] = ':app_key';
snippetConstants[PlatformType.Woocommerce]['secret'] = ':secret';

snippetConstants[PlatformType.Bigcommerce] = {};

snippetConstants[PlatformType.Bigcommerce]['yotpoJS'] = '<script type="text/javascript"> (function e()' +
  '{var e=document.createElement("script");e.type="text/javascript",e.async=true,' + '' +
  'e.src="//staticw2.yotpo.com/:app_key/widget.js";var t=document.getElementsByTagName("script")[0];' + '' +
  't.parentNode.insertBefore(e,t)})();</script> <script type="text/javascript">//<![CDATA[\n' +
  'var div = document.createElement("div");' +
  'div.setAttribute(\'class\', \'yotpo yotpo-main-widget\');' +
  'div.setAttribute(\'data-product-id\',"{{product.id}}");' +
  'div.setAttribute(\'data-name\',"{{product.title}}");' +
  'div.setAttribute(\'data-url\', "{{settings.base_url}}{{product.url}}");' +
  'div.setAttribute(\'data-image-url\', "{{getImage product.main_image \'product\'}}");' +
  'div.setAttribute(\'data-price\', "{{#if product.price.with_tax}}{{product.price.with_tax.value}}{{/if}}' +
  '{{#if product.price.without_tax}}{{product.price.without_tax.value}}{{/if}}");' +
  'div.setAttribute(\'data-currency\', "{{currency_selector.active_currency_code}}");' +
  'document.querySelectorAll(\'.productView\')[0].appendChild(div)' +
  '//]]></script>'
;

snippetConstants[PlatformType.Bigcommerce]['conversionTracking'] = '<script type="text/javascript">(function e()' +
  '{var e=document.createElement("script");e.type="text/javascript",e.async=true,' +
  'e.src="//staticw2.yotpo.com/:app_key/widget.js";var t=document.getElementsByTagName("script")[0];' +
  't.parentNode.insertBefore(e,t)})();</script><script>yotpoTrackConversionData = {orderId: "%%ORDER_ID%%", ' +
  'orderAmount: "%%ORDER_AMOUNT%%", orderCurrency: "USD"}</script><noscript>' +
  '<img src="//api.yotpo.com/conversion_tracking.gif?app_key=:app_key&order_id=%%ORDER_ID%%&' +
  'order_amount=%%ORDER_AMOUNT%%&order_currency=USD" width="1" height="1"></noscript>';

snippetConstants[PlatformType.Magento] = {};

snippetConstants[PlatformType.Magento]['app_key'] = ':app_key';
snippetConstants[PlatformType.Magento]['secret'] = ':secret';

snippetConstants[PlatformType.Magento2] = {};

snippetConstants[PlatformType.Magento2]['changeWidgetLocation'] = '<?php $this->helper(\'Yotpo\Yotpo\Helper\Data\')->' +
  'showWidget($this); ?>';

snippetConstants[PlatformType.Magento2]['app_key'] = ':app_key';
snippetConstants[PlatformType.Magento2]['secret'] = ':secret';
